import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./StockView.module.css";
import { GET_SCHOOL_URL,
         GET_SCHOOL_ITEM_TYPE_URL,
         GET_ITEM_TYPE_URL,
         GET_ITEM_CATEGORY_BY_TYPE_URL,
         GET_ITEM_LIST_BY_TYPE_URL,
         GET_ITEM_LIST_BY_SCHOOL_URL,
         GET_ALL_ITEMS_URL,
         BULK_UPDATE_URL,
         HIDE_ITEMS_URL,
         SHOW_ITEMS_URL  } from "../constant/apiConstants";

const StockView = () => {
  const [selectedFilter, setSelectedFilter] = useState("filter1");
  const [schoolList, setSchoolList] = useState([]);
  const [itemTypeList, setItemTypeList] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedItemType, setSelectedItemType] = useState("");
  const [filteredItemTypeList, setFilteredItemTypeList] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [maxQuantity, setMaxQuantity] = useState('');
  const [editableData, setEditableData] = useState({});
  
  // New states for bulk update
  const [selectedFields, setSelectedFields] = useState({
    itemCode: false,
    description: false,
    itemType: false,
    itemColor: false,
    schoolName: false
  });
  const [showFindReplace, setShowFindReplace] = useState(false);
  const [findText, setFindText] = useState('');
  const [replaceText, setReplaceText] = useState('');
  const [activeField, setActiveField] = useState('itemCode');
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewData, setReviewData] = useState([]);
  
  // New states for hide/show functionality
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  
  const userData = JSON.parse(sessionStorage.getItem('user'));

  useEffect(() => {
    const storeId = userData?.storeId; 
    if (storeId) {
      axios
        .get(GET_SCHOOL_URL, {
          params: { storeId: storeId }
        })
        .then((response) => setSchoolList(response.data))
        .catch((error) => console.error("Error fetching schools:", error));
    } else {
      console.error("Store ID not found in session storage");
    }
  }, []);

  useEffect(() => {
    if (selectedFilter === "filter1" && selectedSchool) {
      const storeId = userData?.storeId;
  
      if (storeId) {
        axios
          .get(GET_SCHOOL_ITEM_TYPE_URL, {
            params: { schoolCode: selectedSchool, storeId: storeId }
          })
          .then((response) => setFilteredItemTypeList(response.data))
          .catch((error) =>
            console.error("Error fetching item types for school:", error)
          );
      } else {
        console.error("Store ID not found in session storage");
      }
    }
  }, [selectedFilter, selectedSchool]);

  useEffect(() => {
    if (selectedFilter === "filter2") {
      const storeId = userData?.storeId;
  
      if (storeId) {
        axios
          .get(GET_ITEM_TYPE_URL, {
            params: { storeId: storeId }
          })
          .then((response) => setItemTypeList(response.data))
          .catch((error) => console.error("Error fetching item types:", error));
      } else {
        console.error("Store ID not found in session storage");
      }
    }
  }, [selectedFilter]);
  
  useEffect(() => {
    const storeId = userData?.storeId;
    
    setLoading(true);
    
    if (selectedFilter === "filter1" && selectedSchool && selectedItemType) {
      axios
        .get(GET_ITEM_CATEGORY_BY_TYPE_URL, {
          params: {
            schoolCode: selectedSchool,
            itemType: selectedItemType,
            showStatus: 'ALL',
            storeId: storeId,
          },
        })
        .then((response) => {
          setData(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data for Filter 1:", error);
          setLoading(false);
        });
    } else if (selectedFilter === "filter2" && selectedItemType) {
      axios
        .get(GET_ITEM_LIST_BY_TYPE_URL, {
          params: {
            itemType: selectedItemType,
            showStatus: 'ALL',
            storeId: storeId,
          },
        })
        .then((response) => {
          setData(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data for Filter 2:", error);
          setLoading(false);
        });
    } else if (selectedFilter === "filter3" && selectedSchool) {
      axios
      .get(GET_ITEM_LIST_BY_SCHOOL_URL, {
        params: {
          schoolCode: selectedSchool,
          showStatus: 'ALL',
          storeId: storeId, 
        },
      })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data for Filter 3:", error);
        setLoading(false);
      });
    } else if (selectedFilter === "filter4") {
      axios
      .get(GET_ALL_ITEMS_URL, {
        params: {
          storeId: storeId,
        },
      })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [selectedFilter, selectedSchool, selectedItemType]);

  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
    if (event.target.value !== "filter1") {
      setSelectedSchool("");
    }
    setSelectedItemType("");
    setData([]);
    setSelectedItems([]);
    setSelectAll(false);
  };

  const handleSchoolChange = (event) => {
    setSelectedSchool(event.target.value);
    setSelectedItemType("");
    setSelectedItems([]);
    setSelectAll(false);
  };

  const handleItemTypeChange = (event) => {
    setSelectedItemType(event.target.value);
    setSelectedItems([]);
    setSelectAll(false);
  };

  const refreshData = () => {
    const storeId = userData?.storeId; 
    
    setLoading(true);
  
    if (selectedFilter === "filter1" && selectedSchool && selectedItemType) {
      axios
        .get(GET_ITEM_CATEGORY_BY_TYPE_URL, {
          params: {
            schoolCode: selectedSchool,
            itemType: selectedItemType,
            showStatus: 'ALL',
            storeId: storeId,
          },
        })
        .then((response) => {
          setData(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    } else if (selectedFilter === "filter2" && selectedItemType) {
      axios
        .get(GET_ITEM_LIST_BY_TYPE_URL, {
          params: {
            itemType: selectedItemType,
            showStatus: 'ALL',
            storeId: storeId,
          },
        })
        .then((response) => {
          setData(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    } else if (selectedFilter === "filter3" && selectedSchool) {
      axios
      .get(GET_ITEM_LIST_BY_SCHOOL_URL, {
        params: {
          schoolCode: selectedSchool,
          showStatus: 'ALL',
          storeId: storeId,
        },
      })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
    } else if (selectedFilter === "filter4") {
      axios
      .get(GET_ALL_ITEMS_URL, {
        params: {
          storeId: storeId,
        },
      })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const handleQuantityFilter = (e) => {
    setMaxQuantity(e.target.value);
  };

  const handleInputChange = (e, id, field) => {
    const { value } = e.target;
    setEditableData((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const handleFieldCheckbox = (field) => {
    setSelectedFields((prev) => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleFindReplace = () => {
    if (!findText) {
      alert('Please enter text to find');
      return;
    }

    const fieldMap = {
      itemCode: 'itemCode',
      description: 'description',
      itemType: 'itemType',
      itemColor: 'itemColor',
      schoolName: 'itemCategory'
    };

    const actualField = fieldMap[activeField];
    let updatedCount = 0;

    filteredData.forEach((item) => {
      const currentValue = item[actualField];
      if (currentValue && currentValue.includes(findText)) {
        const newValue = currentValue.replace(new RegExp(findText, 'g'), replaceText);
        handleInputChange(
          { target: { value: newValue } },
          item.sno,
          actualField
        );
        updatedCount++;
      }
    });

    alert(`Updated ${updatedCount} items`);
  };

  const handleOpenReviewModal = () => {
    const changes = [];
    
    Object.keys(editableData).forEach((sno) => {
      const originalItem = filteredData.find(item => item.sno === parseInt(sno));
      if (!originalItem) return;

      const itemChanges = {
        sno: parseInt(sno),
        itemCode: originalItem.itemCode,
        description: originalItem.description,
        changes: {}
      };

      const fieldMap = {
        itemCode: 'itemCode',
        description: 'description',
        itemType: 'itemType',
        itemColor: 'itemColor',
        itemCategory: 'schoolName'
      };

      Object.keys(editableData[sno]).forEach((field) => {
        const newValue = editableData[sno][field];
        const oldValue = originalItem[field];
        
        if (newValue !== oldValue) {
          const displayField = Object.keys(fieldMap).find(key => fieldMap[key] === field) || field;
          itemChanges.changes[field] = {
            old: oldValue,
            new: newValue,
            displayName: displayField
          };
        }
      });

      if (Object.keys(itemChanges.changes).length > 0) {
        changes.push(itemChanges);
      }
    });

    if (changes.length === 0) {
      alert('No changes to review');
      return;
    }

    setReviewData(changes);
    setShowReviewModal(true);
  };

  const handleDiscardItem = (sno) => {
    setReviewData(prev => prev.filter(item => item.sno !== sno));
  };

  const handleSubmitBulkUpdate = async () => {
    if (reviewData.length === 0) {
      alert('No items to update');
      setShowReviewModal(false);
      return;
    }

    try {
      const storeId = userData?.storeId;
      
      const stockUpdateList = reviewData.map(item => {
        const valueToUpdate = {};
        
        Object.keys(item.changes).forEach(field => {
          if (field === 'itemCategory') {
            valueToUpdate.schoolName = item.changes[field].new;
          } else {
            valueToUpdate[field] = item.changes[field].new;
          }
        });

        return {
          barcodeId: item.sno,
          storeId: storeId,
          valueToUpdate: valueToUpdate
        };
      });

      const response = await axios.post(
        BULK_UPDATE_URL,
        stockUpdateList,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data === 'SUCCESS') {
        alert('Bulk update completed successfully');
        setEditableData({});
        setSelectedFields({
          itemCode: false,
          description: false,
          itemType: false,
          itemColor: false,
          schoolName: false
        });
        setShowReviewModal(false);
        setReviewData([]);
        refreshData();
      } else {
        alert('Failed to update inventory.');
      }
    } catch (error) {
      console.error('Error updating inventory:', error);
      alert('An error occurred while updating the inventory.');
    }
  };

  const handleDiscard = () => {
    setEditableData({});
    setSelectedFields({
      itemCode: false,
      description: false,
      itemType: false,
      itemColor: false,
      schoolName: false
    });
  };

  // New functions for hide/show functionality
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      setSelectedItems(filteredData.map(item => item.sno));
    }
    setSelectAll(!selectAll);
  };

  const handleItemSelection = (sno) => {
    setSelectedItems(prev => {
      if (prev.includes(sno)) {
        const newSelection = prev.filter(id => id !== sno);
        if (newSelection.length === 0) {
          setSelectAll(false);
        }
        return newSelection;
      } else {
        const newSelection = [...prev, sno];
        if (newSelection.length === filteredData.length) {
          setSelectAll(true);
        }
        return newSelection;
      }
    });
  };

  const handleHideItems = async () => {
    if (selectedItems.length === 0) {
      alert('Please select items to hide');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        HIDE_ITEMS_URL,
        selectedItems,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data === 'SUCCESS') {
        alert(`Successfully hidden ${selectedItems.length} items`);
        setSelectedItems([]);
        setSelectAll(false);
        refreshData();
      } else {
        alert('Failed to hide items');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error hiding items:', error);
      alert('An error occurred while hiding items');
      setLoading(false);
    }
  };

  const handleShowItems = async () => {
    if (selectedItems.length === 0) {
      alert('Please select items to show');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        SHOW_ITEMS_URL,
        selectedItems,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data === 'SUCCESS') {
        alert(`Successfully shown ${selectedItems.length} items`);
        setSelectedItems([]);
        setSelectAll(false);
        refreshData();
      } else {
        alert('Failed to show items');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error showing items:', error);
      alert('An error occurred while showing items');
      setLoading(false);
    }
  };

  const filteredData = data
  .filter((item) => {
    const matchesSearchTerm =
      (item.itemCode && item.itemCode.toLowerCase().includes(searchTerm)) ||
      (item.itemName && item.itemName.toLowerCase().includes(searchTerm)) ||
      (item.itemType && item.itemType.toLowerCase().includes(searchTerm)) ||
      (item.itemColor && item.itemColor.toLowerCase().includes(searchTerm)) ||
      (item.itemSize && item.itemSize.toLowerCase().includes(searchTerm)) ||
      (item.itemCategory && item.itemCategory.toLowerCase().includes(searchTerm)) ||
      (item.group_id && item.group_id.toLowerCase().includes(searchTerm));
  
    if (maxQuantity === '') {
      return matchesSearchTerm;
    }
    
    const matchesQuantityFilter = 
      (item.quantity !== undefined && item.quantity <= parseInt(maxQuantity, 10));
    
    return matchesSearchTerm && matchesQuantityFilter;
  })
  .sort((a, b) => {
    if (maxQuantity !== '') {
      return (b.quantity || 0) - (a.quantity || 0);
    }
    return 0;
  });

  const hasSelectedFields = Object.values(selectedFields).some(v => v);


  return (
  <div className={styles.pageWrapper}>
    {loading && <div className={styles.spinner}></div>}
    
    <div className={`${styles.mainLayout} ${loading ? styles.blur : ""}`}>
      {/* Left Sidebar Controls */}
      <div className={styles.leftSidebar}>
        <h3 className={styles.title}>View Stock</h3>

        {/* Filter Options */}
        <div className={styles.filterSection}>
          <h4 className={styles.sectionTitle}>Filter Options</h4>
          <div className={styles.radioGroup}>
            <div className={styles.radio}>
              <input
                type="radio"  
                id="filter1"
                name="filter"
                value="filter1"
                checked={selectedFilter === "filter1"}
                onChange={handleFilterChange}
              />
              <label htmlFor="filter1">School and Item</label>
            </div>

            <div className={styles.radio}>
              <input
                type="radio"
                id="filter2"
                name="filter"
                value="filter2"
                checked={selectedFilter === "filter2"}
                onChange={handleFilterChange}
              />
              <label htmlFor="filter2">Item</label>
            </div>

            <div className={styles.radio}>
              <input
                type="radio"
                id="filter3"
                name="filter"
                value="filter3"
                checked={selectedFilter === "filter3"}
                onChange={handleFilterChange}
              />
              <label htmlFor="filter3">School</label>
            </div>
          </div>

          {/* School Dropdown */}
          {(selectedFilter === "filter1" || selectedFilter === "filter3") && (
            <div className={styles.selectGroup}>
              <label htmlFor="school">School:</label>
              <select
                id="school"
                value={selectedSchool}
                onChange={handleSchoolChange}
              >
                <option value="">Select a school</option>
                {schoolList.map((school) => (
                  <option key={school} value={school}>
                    {school}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Item Type Dropdown */}
          {(selectedFilter === "filter1" && selectedSchool) || selectedFilter === "filter2" ? (
            <div className={styles.selectGroup}>
              <label htmlFor="itemType">Item Type:</label>
              <select
                id="itemType"
                value={selectedItemType}
                onChange={handleItemTypeChange}
              >
                <option value="">Select an item type</option>
                {(selectedFilter === "filter1" ? filteredItemTypeList : itemTypeList).map((itemType) => (
                  <option key={itemType} value={itemType}>
                    {itemType}
                  </option>
                ))}
              </select>
            </div>
          ) : null}
        </div>

        {/* Search and Filter */}
        {data.length > 0 && (
          <>
            <div className={styles.searchSection}>
              <h4 className={styles.sectionTitle}>Search & Filter</h4>
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearch}
                className={styles.searchBar}
              />
              
              <input
                type="number"
                placeholder="Max Quantity"
                value={maxQuantity}
                onChange={handleQuantityFilter}
                className={styles.quantityFilter}
              />
            </div>

            {/* Item Selection Section */}
            <div className={styles.itemSelectionSection}>
              <h4 className={styles.sectionTitle}>Item Actions</h4>
              <div className={styles.selectionInfo}>
                <span className={styles.selectedCount}>
                  {selectedItems.length} item{selectedItems.length !== 1 ? 's' : ''} selected
                </span>
              </div>
              <div className={styles.itemActionButtons}>
                <button
                  className={styles.hideBtn}
                  onClick={handleHideItems}
                  disabled={selectedItems.length === 0}
                >
                  Delete Selected
                </button>
                <button
                  className={styles.showBtn}
                  onClick={handleShowItems}
                  disabled={selectedItems.length === 0}
                >
                  Show Selected
                </button>
              </div>
            </div>

            {/* Bulk Edit Section */}
            <div className={styles.bulkEditSection}>
              <h4 className={styles.sectionTitle}>Bulk Edit Fields</h4>
              <div className={styles.bulkEditCheckboxes}>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={selectedFields.itemCode}
                    onChange={() => handleFieldCheckbox('itemCode')}
                  />
                  Item Code
                </label>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={selectedFields.description}
                    onChange={() => handleFieldCheckbox('description')}
                  />
                  Description
                </label>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={selectedFields.itemType}
                    onChange={() => handleFieldCheckbox('itemType')}
                  />
                  Item Type
                </label>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={selectedFields.itemColor}
                    onChange={() => handleFieldCheckbox('itemColor')}
                  />
                  Item Color
                </label>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={selectedFields.schoolName}
                    onChange={() => handleFieldCheckbox('schoolName')}
                  />
                  School Name
                </label>
              </div>

              {hasSelectedFields && (
                <button
                  className={styles.findReplaceToggle}
                  onClick={() => setShowFindReplace(!showFindReplace)}
                >
                  {showFindReplace ? 'Hide' : 'Show'} Find & Replace
                </button>
              )}
            </div>

            {/* Find and Replace Tool */}
            {showFindReplace && hasSelectedFields && (
              <div className={styles.findReplacePanel}>
                <h4 className={styles.sectionTitle}>Find & Replace</h4>
                <div className={styles.findReplaceControls}>
                  <div className={styles.findReplaceField}>
                    <label>Field:</label>
                    <select 
                      value={activeField} 
                      onChange={(e) => setActiveField(e.target.value)}
                      className={styles.findReplaceSelect}
                    >
                      {selectedFields.itemCode && <option value="itemCode">Item Code</option>}
                      {selectedFields.description && <option value="description">Description</option>}
                      {selectedFields.itemType && <option value="itemType">Item Type</option>}
                      {selectedFields.itemColor && <option value="itemColor">Item Color</option>}
                      {selectedFields.schoolName && <option value="schoolName">School Name</option>}
                    </select>
                  </div>
                  <div className={styles.findReplaceField}>
                    <label>Find:</label>
                    <input
                      type="text"
                      value={findText}
                      onChange={(e) => setFindText(e.target.value)}
                      placeholder="Text to find"
                      className={styles.findReplaceInput}
                    />
                  </div>
                  <div className={styles.findReplaceField}>
                    <label>Replace:</label>
                    <input
                      type="text"
                      value={replaceText}
                      onChange={(e) => setReplaceText(e.target.value)}
                      placeholder="Replacement text"
                      className={styles.findReplaceInput}
                    />
                  </div>
                  <button 
                    className={styles.findReplaceButton}
                    onClick={handleFindReplace}
                  >
                    Replace All
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Right Content Area */}
      <div className={styles.contentArea}>
        {data.length > 0 ? (
          <>
            <div className={styles.tableContainer}>
              <div className={styles.tableWrapper}>
                {filteredData.length > 0 ? (
                  <table className={styles.table}>
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            className={styles.selectAllCheckbox}
                          />
                        </th>
                        <th>S.No</th>
                        <th>Item Code</th>
                        <th>Description</th>
                        <th>Item Type</th>
                        <th>Item Color</th>
                        <th>Item Size</th>
                        <th>School Name</th>
                        <th>Status</th>
                        <th>Price</th>
                        <th>Wholesale Price</th>
                        <th>Available Quantity</th>
                        <th>Group ID</th>
                        <th>Store Id</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((item, rowIndex) => (
                        <tr key={rowIndex} className={rowIndex % 2 === 0 ? styles.evenRow : styles.oddRow}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedItems.includes(item.sno)}
                              onChange={() => handleItemSelection(item.sno)}
                              className={styles.itemCheckbox}
                            />
                          </td>
                          <td>{item.sno}</td>
                          <td>
                            {selectedFields.itemCode ? (
                              <input
                                type="text"
                                value={editableData[item.sno]?.itemCode ?? item.itemCode}
                                onChange={(e) => handleInputChange(e, item.sno, 'itemCode')}
                                className={styles.editInput}
                              />
                            ) : (
                              item.itemCode
                            )}
                          </td>
                          <td>
                            {selectedFields.description ? (
                              <input
                                type="text"
                                value={editableData[item.sno]?.description ?? item.description}
                                onChange={(e) => handleInputChange(e, item.sno, 'description')}
                                className={styles.editInput}
                              />
                            ) : (
                              item.description
                            )}
                          </td>
                          <td>
                            {selectedFields.itemType ? (
                              <input
                                type="text"
                                value={editableData[item.sno]?.itemType ?? item.itemType}
                                onChange={(e) => handleInputChange(e, item.sno, 'itemType')}
                                className={styles.editInput}
                              />
                            ) : (
                              item.itemType
                            )}
                          </td>
                          <td>
                            {selectedFields.itemColor ? (
                              <input
                                type="text"
                                value={editableData[item.sno]?.itemColor ?? item.itemColor}
                                onChange={(e) => handleInputChange(e, item.sno, 'itemColor')}
                                className={styles.editInput}
                              />
                            ) : (
                              item.itemColor
                            )}
                          </td>
                          <td>{item.itemSize}</td>
                          <td>
                            {selectedFields.schoolName ? (
                              <input
                                type="text"
                                value={editableData[item.sno]?.itemCategory ?? item.itemCategory}
                                onChange={(e) => handleInputChange(e, item.sno, 'itemCategory')}
                                className={styles.editInput}
                              />
                            ) : (
                              item.itemCategory
                            )}
                          </td>
                          <td style={{ color: item.itemActiveStatus === 'active' ? 'green' : item.itemActiveStatus === 'restricted' ? 'red' : 'black' }}>
                            {item.itemActiveStatus.toUpperCase()}
                          </td>
                          <td>{item.price}</td>
                          <td>{item.wholeSalePrice}</td>
                          <td>{item.quantity}</td>
                          <td>{item.group_id}</td>
                          <td>{item.storeId}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p className={styles.noDataMessage}>No data found</p>
                )}
              </div>
            </div>

            {/* Fixed Footer with Action Buttons */}
            {hasSelectedFields && (
              <div className={styles.fixedFooter}>
                <button
                  onClick={handleDiscard}
                  className={styles.cancelBtn}
                >
                  Discard Changes
                </button>
                <button
                  onClick={handleOpenReviewModal}
                  className={styles.submitBtn}
                >
                  Review & Submit
                </button>
              </div>
            )}
          </>
        ) : (
          <div className={styles.emptyState}>
            <p>Select filter options to view stock</p>
          </div>
        )}
      </div>
    </div>

    {/* Review Modal */}
    {showReviewModal && (
      <div className={styles.modalOverlay}>
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <h3>Review Changes</h3>
            <button 
              className={styles.modalClose}
              onClick={() => setShowReviewModal(false)}
            >
              ×
            </button>
          </div>
          
          <div className={styles.modalBody}>
            {reviewData.length === 0 ? (
              <p className={styles.noChanges}>No changes to review</p>
            ) : (
              reviewData.map((item, index) => (
                <div key={index} className={styles.reviewItem}>
                  <div className={styles.reviewItemHeader}>
                    <span className={styles.reviewItemTitle}>
                      S.No: {item.sno} | {item.itemCode} - {item.description}
                    </span>
                    <button
                      className={styles.discardItemBtn}
                      onClick={() => handleDiscardItem(item.sno)}
                    >
                      Discard
                    </button>
                  </div>
                  
                  <div className={styles.reviewChanges}>
                    {Object.keys(item.changes).map((field, idx) => (
                      <div key={idx} className={styles.changeRow}>
                        <span className={styles.fieldName}>
                          {item.changes[field].displayName}:
                        </span>
                        <span className={styles.oldValue}>
                          {item.changes[field].old || '(empty)'}
                        </span>
                        <span className={styles.arrow}>→</span>
                        <span className={styles.newValue}>
                          {item.changes[field].new}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}
          </div>
          
          <div className={styles.modalFooter}>
            <button
              className={styles.modalCancelBtn}
              onClick={() => setShowReviewModal(false)}
            >
              Cancel
            </button>
            <button
              className={styles.modalSubmitBtn}
              onClick={handleSubmitBulkUpdate}
              disabled={reviewData.length === 0}
            >
              Submit Updates ({reviewData.length})
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
);
};

export default StockView;